module.exports = __webpack_public_path__ + "static/media/5.24a4be51.jpg";